// @flow
import nodeFetch from 'node-fetch';
import browserFetch from 'fetch-ponyfill';

import inBrowser from './inBrowser';

const CACHE = new Map();
const fetch = inBrowser() ? browserFetch().fetch : nodeFetch;

class RequestError extends Error {
  statusCode: number;

  constructor({ statusCode, statusText }: {
    statusCode: number;
    statusText: string;
  }) {
    super(statusText);
    this.statusCode = statusCode;
  }
}

export async function fetchJSON(url: string, opts?: Object): Promise<?Object> {
  let data = CACHE.get(url);

  if (!data) {
    data = await fetch(url, opts).then(res => {
      const { status, statusText } = res;

      if (status >= 200 && status < 300) {
        return res.json();
      }

      throw new RequestError({
        statusText,
        statusCode: status
      });
    });

    CACHE.set(url, data);
  }

  return typeof data === 'object' ? data : null;
}



// WEBPACK FOOTER //
// ./src/utils/fetch.js